import { Inject, Injectable } from '@angular/core';

export interface APIConfiguration {
  url: string;
}

@Injectable()
export class APIConfig {
  get api(): APIConfiguration {
    return {
      url: this.apiUrl,
    };
  }

  private apiUrl = 'https://api.inwedio.com';

  async loadConfig() {
    try {
      const result = await fetch('/assets/api.json');
      const config: APIConfiguration = await result.json();
      if (config?.url) {
        this.apiUrl = config.url;
      }
    } catch (error) {
      console.error(error);
    }

    // console.log({ apiUrl: this.apiUrl });
  }
}
